import type { TFunction } from 'i18next'
import { DateTime } from 'luxon'
import { z } from 'zod'

export const getProductionPlanObligationSchema = (t: TFunction) =>
  z
    .object({
      countryCode: z.string(),
      regulationObjectCode: z.string(),
      updatedAt: z.custom<DateTime>((val) => val instanceof DateTime && val.isValid, {
        message: t('portfolio_hierarchy.regulation_object.production_plan_obligation.edit.updated_at_invalid_error'),
      }),
      productionPlanName: z.string().optional(),
      obligationPeriod: z.object({
        startAt: z
          .custom<DateTime | null>((val) => val === null || (val instanceof DateTime && val.isValid), {
            message: t('portfolio_hierarchy.regulation_object.production_plan_obligation.edit.start_at_invalid_error'),
          })
          .nullable(),
        endAt: z
          .custom<DateTime | null | undefined>(
            (val) => val === null || val === undefined || (val instanceof DateTime && val.isValid),
            {
              message: t('portfolio_hierarchy.regulation_object.production_plan_obligation.edit.end_at_invalid_error'),
            },
          )
          .nullish(),
      }),
    })
    .refine(
      ({ obligationPeriod }) => {
        // If endAt is filled, startAt must also be filled
        if (obligationPeriod?.endAt && !obligationPeriod?.startAt) {
          return false
        }

        // If both are filled, startAt must be smaller than endAt
        if (obligationPeriod?.startAt && obligationPeriod?.endAt) {
          return obligationPeriod.startAt.startOf('second') < obligationPeriod.endAt.startOf('second')
        }

        // Otherwise, valid
        return true
      },
      {
        message: t(
          'portfolio_hierarchy.regulation_object.production_plan_obligation.edit.end_at_before_start_at_error',
        ),
        path: ['obligationPeriod', 'endAt'],
      },
    )
